<template>
    <div class="bill-charge">
        <modal v-if="loginType === 'COMPANY'" class="bill-charge-list" :display="modalStatus.billCharge" @modalStatus="closeModal()" >
            <h1>
                引用費用組合
            </h1>
            <table-search v-model="filter.word" ></table-search>
            <div class="content">
                <div class="no-result" v-if="!filterByWord.length">
                    0 筆資料
                </div>
                <div class="list" v-for="(item, index) in filterByWord" :key="index">
                    <radio :val="index" v-model="selected" :isPropChecked="selected === index" :msg="item.billSettingName"></radio>
                    <div class="bill-charge-item">
                        <div class="bill-group h-align" v-for="(charge, cIndex) in item.billChargeMode" :key="cIndex">
                            <img v-if="charge.itemName === '電費'" class="bill-icon" src="@/assets/img/component/billCharge/electrict.svg" alt="">
                            <img v-if="charge.itemName === '水費'" class="bill-icon" src="@/assets/img/component/billCharge/water.svg" alt="">
                            <img v-if="charge.itemName === '瓦斯費'" class="bill-icon" src="@/assets/img/component/billCharge/gas.svg" alt="">
                            <img v-if="charge.itemName === '網路費'" class="bill-icon" src="@/assets/img/component/billCharge/network.svg" alt="">
                            <img v-if="charge.itemName === '管理費'" class="bill-icon" src="@/assets/img/component/billCharge/manage.svg" alt="">
                            <img v-if="charge.itemName === '有線電視'" class="bill-icon" src="@/assets/img/component/billCharge/tv.svg" alt="">
                            <img v-if="charge.itemName === '停車費'" class="bill-icon" src="@/assets/img/component/billCharge/parking.svg" alt="">
                            <img v-if="charge.itemName === '清潔費'" class="bill-icon" src="@/assets/img/component/billCharge/clean.svg" alt="">
                            {{charge.itemName}}：{{transType(charge.type)}} {{charge.amount?toCurrency(charge.amount)+' 元':''}} 
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="importData" :disabled="isDisabled">引用此組合</button>
            </div>
        </modal>
        <div v-if="loginType === 'COMPANY'" class="add-combination h-align" @click="modalStatus.billCharge=true">
            <img src="@/assets/img/icon/plus_pink.svg" alt="">
            引用費用組合
        </div>
        <div v-if="isElectricity" class="bill-block">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    {{electricity.itemName}}
                </div>
                <!-- <span v-show="error.moveInDateErr" class="error-with-title">{{error.moveInDateErr}}</span> -->
            </label>
            <div class="radio-arear h-align">
                <radio val="BY_KILOWATT" v-model="electricity.type" :isPropChecked="electricity.type === 'BY_KILOWATT'" msg="依度數繳交"></radio>
                <radio val="BY_MONTH" v-model="electricity.type" :isPropChecked="electricity.type === 'BY_MONTH'" msg="每月約定金額"></radio>
                <radio val="PAY_BY_SELF" v-model="electricity.type" :isPropChecked="electricity.type === 'PAY_BY_SELF'" msg="依帳單繳交"></radio>
            </div>
            <div v-if="electricity.type!=='PAY_BY_SELF'" class="input-arear">
                <span v-if="electricity.type === 'BY_KILOWATT'" class="unit">每度</span>
                <span v-else-if="electricity.type === 'BY_MONTH'" class="unit">每月</span>
                <span class="quantifier">元</span>
                <input :class="{'error': electricityError}" v-if="electricity.type === 'BY_KILOWATT'" v-model.number="electricity.amount" type="number" :placeholder="electricity.type === 'BY_KILOWATT'?'請輸入每度電金額':'請輸入每月電金額'">
                <input v-else-if="electricity.type === 'BY_MONTH'" v-model.number="electricity.amount" onkeyup="this.value=this.value.replace(/\D/g,'')" type="number" :placeholder="electricity.type === 'BY_KILOWATT'?'請輸入每度電金額':'請輸入每月電金額'">
            </div>
        </div>
        <div class="bill-block other-setting">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    其他費用設定
                </div>
                <!-- <span v-show="error.moveInDateErr" class="error-with-title">{{error.moveInDateErr}}</span> -->
            </label>
            <div class="radio-arear h-align">
                <bill-checkbox v-for="(item, index) in includeListDisplayByFalse" :key="'includeList'+index" :isPropChecked="isActive(item)" v-model="bill" :val="item" :msg="item"></bill-checkbox>
            </div>
        </div>
        <div class="bill-block" v-for="(item, index) in bill" :key="'bill'+index">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    {{item}}
                </div>
            </label>
            <div class="radio-arear h-align">
                <radio v-if="item === '水費' || item === '瓦斯費'" val="BY_KILOWATT" v-model="insertData[index].type" :isPropChecked="insertData[index].type === 'BY_KILOWATT'" msg="依度數繳交"></radio>
                <radio val="BY_MONTH" v-model="insertData[index].type" :isPropChecked="insertData[index].type === 'BY_MONTH'" msg="每月約定金額"></radio>
                <radio val="PAY_BY_SELF" v-model="insertData[index].type" :isPropChecked="insertData[index].type === 'PAY_BY_SELF'" msg="依帳單繳交"></radio>
            </div>
            <div v-if="insertData[index].type!=='PAY_BY_SELF'" class="input-arear">
                <span v-if="insertData[index].type === 'BY_KILOWATT'" class="unit">每度</span>
                <span v-else-if="insertData[index].type === 'BY_MONTH'" class="unit">每月</span>
                <span class="quantifier">元</span>
                <input v-if="insertData[index].type === 'BY_KILOWATT'" :class="{'error': error[index]}" v-model.number="insertData[index].amount" type="number" :placeholder="insertData[index].type === 'BY_KILOWATT'?'請輸入每度電金額':'請輸入每月電金額'">
                <input v-else-if="insertData[index].type === 'BY_MONTH'" v-model.number="insertData[index].amount" onkeyup="this.value=this.value.replace(/\D/g,'')"  type="number" :placeholder="insertData[index].type === 'BY_KILOWATT'?'請輸入每度電金額':'請輸入每月電金額'">
            </div>
        </div>
    </div>
</template>
<script>
import radio from '@/components/bussiness/widges/input/radio.vue';
import billCheckbox from '@/components/bussiness/widges/input/billCheckbox.vue';
import Modal from '@/components/widge/Modal.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            electricity: {
                itemName: '電費',
                type: 'BY_KILOWATT',
                amount: null
            },
            bill: [],
            insertData: [],
            electricityError: null,
            error: [],
            modalStatus: {
                billCharge: false
            },
            filter:{
                word: null
            },
            selected: null
        }
    },
    props: {
        includeList: {
            type: Array,
            default: ()=>{return []}
        },
        editData: {
            type: Array,
            default: ()=>{return []}
        },
        loginType: {
            type: String,
            default: 'COMPANY'
        },
    },
    created() {
        if(this.loginType === 'COMPANY'){
            this.$store.dispatch('getBizBillChargeList')
        }
    },
    watch: {
        bill: function (val){
            for (let i = 0; i < val.length; i++) {
                const item = val[i]
                const inList = this.itemInList(item)
                if(!inList){
                    this.addItem(item)
                }
            }
            this.removeItem()

        },
        electricity: {
            handler: function (val) {
                console.log(val)
                var decimal = /^[0-9]+(\.[0-9]?)?$/;
                if(val.amount && val.type === 'BY_KILOWATT'){
                    if(decimal.test(val.amount)){
                        this.electricityError = false
                    }else{
                        this.electricityError = true
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '請輸入小數1位內',type: 'error',closeBtn: false})
                    }
                }else{
                    this.electricityError = false
                }
                let data  = JSON.parse(JSON.stringify(this.insertData))
                if(this.isElectricity){
                    data.push(this.electricity)
                }
                this.$emit('input', data)
                this.$emit('error', this.isError())
            },
            deep: true
        },
        insertData: {
            handler: function (val) {
                let data  = JSON.parse(JSON.stringify(val))
                if(this.isElectricity){
                    data.push(this.electricity)
                }
                if(val.length){
                    var decimal = /^[0-9]+(\.[0-9]?)?$/;
                    for (let i = 0; i < val.length; i++) {
                        const element = val[i];
                        if(element.amount && element.type === 'BY_KILOWATT'){
                            console.log(element)
                            if(decimal.test(element.amount)){
                                this.error[i] = false
                            }else{
                                this.error[i] = true
                                this.$store.dispatch('setAlarmStatus', {status: true,title: '請輸入小數1位內',type: 'error',closeBtn: false})
                            }
                        }else{
                            this.error[i] = false
                        }
                    }
                }
                this.$emit('input', data)
                this.$emit('error', this.isError())

            },
            deep: true
        },
        // includeListDisplayByFalse: {
        //     handler: function (val) {
        //         let data  = JSON.parse(JSON.stringify(val))
        //         data.push(this.electricity)
        //         this.$emit('input', data)
        //     },
        //     deep: true
        // },
        editData:{
            handler: function (val) {
                this.transDataToInsertData(val)
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        transDataToInsertData: function (list){
            this.insertData = []
            this.bill = []
            console.log(list)
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.type && element.itemName !== '電費'){
                    this.insertData.push(element)
                    this.bill.push(element.itemName)
                }else if(element.type && element.itemName === '電費'){
                    this.electricity.type = element.type
                    this.electricity.amount = element.amount
                }
            }
        },
        transType: function (type){
            if(type === 'BY_KILOWATT'){
                return '每度'
            }else if(type === 'BY_MONTH'){
                return '每月'
            }else if(type === 'PAY_BY_SELF'){
                return '依帳單繳交'
            }
        },
        itemInList: function (item){
            const list = this.insertData
            let inList = false
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === item){
                    inList = true
                    break
                }
            }
            return inList
        },
        addItem: function (item) {
            this.insertData.push({
                itemName: item,
                type: item === '水費' || item === '瓦斯費'?'BY_KILOWATT':'BY_MONTH',
                amount: null
            })
        },
        removeItem: function () {
            const list = this.insertData
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(this.bill.indexOf(element.itemName) === -1){
                    list.splice(i, 1)
                }
            }

        },
        isActive: function (item){
            return this.bill.includes(item)
        },
        importData: function () {
            const list = this.filterByWord[this.selected].billChargeMode
            this.$store.dispatch('setAlarmStatus', {status: true,title: '成功引用費用組合',type: 'success',closeBtn: false})
            this.transDataToInsertData(list)
            this.closeModal()
        },
        closeModal: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.modalStatus.billCharge = false
        },
        isError: function () {
            let boolean = false
            if(this.electricityError){
                boolean = true
            }
            for (let i = 0; i < this.error.length; i++) {
                const element = this.error[i];
                if(element){
                    boolean = true
                }
            }
            return boolean
        },
        getEleEditDataAmount: function () {
            const list = this.editData
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === '電費'){
                    return element.amount
                }
            }
        }
    },
    computed: {
        isDisabled: function () {
            if(this.selected===null){
                return true
            }else{
                return false
            }
        },
        includeListDisplayByFalse: function () {
            let arr = []
            this.includeList.forEach(item=>{
                if(!item.check && item.itemName !== '電費'){
                    arr.push(item.itemName)
                }else if(!item.check && item.itemName === '電費'){
                    console.log(item.itemName)
                    if(!this.editData.length){
                        this.electricity.amount = null
                    }else{
                        let data  = JSON.parse(JSON.stringify(this.insertData))
                        if(this.isElectricity){
                            data.push(this.electricity)
                        }
                        this.$emit('input', data)
                    }
                }else{
                    if(item.itemName === '電費'){
                        if(!this.editData.length){
                            this.electricity.amount = 0
                        }else{
                            let data  = JSON.parse(JSON.stringify(this.insertData))
                            if(this.isElectricity){
                                data.push(this.electricity)
                            }
                            this.$emit('input', data)
                        }
                    }
                    for (let i = 0; i < this.bill.length; i++) {
                        const element = this.bill[i];
                        if(element === item.itemName){
                            this.bill.splice(i, 1)
                        }
                    }
                }
            })
            return arr
        },
        isElectricity: function () {
            let flag = true
            this.includeList.forEach(item=>{
                if(item.check && item.itemName === '電費'){
                    flag = false
                }
            })
            return flag
        },
        filterByWord: function () {
            return this.billChargeList.filter((item) => {
                if( this.filter.word ){
                    if(item.billSettingName.includes(this.filter.word)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            billChargeList: 'GET_BIZ_BILL_CHARGE_LIST',
        })
    },
    components: {
        radio,
        billCheckbox,
        Modal,
        TableSearch
    }
}
</script>
<style lang="scss" scoped>
.bill-charge{
    #modal.bill-charge-list{
        .modal-content{
            width: 664px;
            padding: 0 !important;
            .detail{
                align-items: flex-start !important;
                h1{
                    display: flex;
                    font-size: 24px;
                    margin: auto;
                    margin-top: 32px;
                    margin-bottom: 32px;
                }
                .table-search{
                    width: 600px;
                    margin-bottom: 27px;
                }
                .content{
                    width: 600px;
                    height: 350px;
                    margin-bottom: 8px;
                    padding: 0px 32px;
                    overflow-x: hidden;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .no-result{
                        text-align: center;
                        margin-top: 40px;
                    }
                    .list{
                        border-bottom: 1px solid #f3f3f3;
                        margin-bottom: 16px;
                        padding-bottom: 16px;
                        .bill-charge-item{
                            display: flex;
                            align-items: flex-start;
                            flex-wrap: wrap;
                            margin-top: 14px;
                            .bill-group{
                                width: 200px;
                                margin-bottom: 8px;
                                .bill-icon{
                                    width: 24px;
                                    margin-right: 2px;
                                }
                            }
                        }
                    }
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                }
            }
        }
    }
    .add-combination{
        justify-content: center;
        width: 424px;
        border-radius: 4px;
        border: solid 1px #ff9275;
        background-color: rgba(255, 146, 117, 0.1);
        height: 42px;
        cursor: pointer;
        margin-bottom: 24px;
    }
    .bill-block{
        width: 424px;
        margin-bottom: 24px;
        &.other-setting{
            width: 600px;
        }
        .radio-arear{
            margin-bottom: 11px;
            >.radio{
                margin-right: 20px;
            }
            >.bill-checkbox{
                margin-right: 21px;
            }
        }
        .input-arear{
            >input{
                padding-left: 48px;
                width: 424px;
                box-sizing: border-box;
            }
            .unit{
                position: absolute;
                left: 16px;
                top: 12px;
            }
            .quantifier{
                position: absolute;
                right: 16px;
                top: 12px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/billCharge.vue